import { AlertTriangle, Inbox, Loader2, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export const LoadingState = ({ label = "Chargement des données…", rows = 4 }) => (
  <div data-testid="loading-state" className="p-4 space-y-2">
    <div className="flex items-center gap-2 text-xs text-muted-foreground"><Loader2 className="h-3.5 w-3.5 animate-spin" />{label}</div>
    {Array.from({ length: rows }).map((_, i) => <div key={i} className="h-7 bg-muted/50 rounded-sm animate-pulse" style={{ width: `${90 - i * 12}%` }} />)}
  </div>
);

export const EmptyState = ({ title = "Aucune donnée", hint, icon: Icon = Inbox }) => (
  <div data-testid="empty-state" className="p-8 flex flex-col items-center text-center gap-2">
    <Icon className="h-6 w-6 text-muted-foreground/60" />
    <div className="text-sm font-medium">{title}</div>
    {hint && <div className="text-xs text-muted-foreground max-w-sm">{hint}</div>}
  </div>
);

export const ErrorState = ({ error, onRetry }) => (
  <div data-testid="error-state" className="p-6 flex flex-col items-center text-center gap-2 border border-red-500/30 bg-red-950/20 rounded-sm">
    <AlertTriangle className="h-5 w-5 text-red-400" />
    <div className="text-sm font-medium text-red-300">Erreur de chargement</div>
    <div className="text-xs text-muted-foreground font-mono">{error?.message || String(error)}</div>
    {onRetry && <Button size="sm" variant="outline" onClick={onRetry} data-testid="retry-button"><RefreshCw className="h-3 w-3 mr-1" />Réessayer</Button>}
  </div>
);
